<template>
  <div class="mb-4">
    <label
      v-if="label"
      :class="clsx(
        ['select-none text-base/6 text-slate-950 sm:text-sm/6 font-medium'],
        $attrs.disabled && 'opacity-50'
      )"
    >
      {{ label }}
    </label>

    <span
      :class="clsx(
          [
          // Basic layout
          'relative block w-full',
          // Background color + shadow applied to inset pseudo element, so shadow blends with border in light mode
          'before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow',
          // Focus ring
          'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset after:ring-transparent sm:after:focus-within:ring-2 sm:after:focus-within:ring-primary-700',
          // Disabled state
          'has-[[disabled]]:opacity-50 before:has-[[disabled]]:bg-slate-950/5 before:has-[[disabled]]:shadow-none',
        ],
        label && 'mt-2'
      )"
    >
      <textarea
        v-bind="$attrs"
        v-model="model"
        :class="clsx(
          [
            // Basic layout
            'relative block w-full appearance-none rounded-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing.3)-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
            // Typography
            'text-base/6 text-slate-950 placeholder:text-slate-500 sm:text-sm/6',
            // Border
            'border border-slate-950/10 hover:border-slate-950/20',
            // Background color
            'bg-transparent',
            // Hide default focus styles
            'focus:outline-none focus:shadow-none focus:ring-0',
            // Disabled state
            'disabled:border-slate-950/20',
            // Resizable
            resizable ? 'resize-y' : 'resize-none h-full',
          ],
          error && '!border-error hover:!border-error'
        )"
      />
    </span>

    <p
      v-if="description"
      :class="clsx(
        ['mt-2 text-base/6 text-slate-500 sm:text-sm/6'],
        $attrs.disabled && 'opacity-50'
      )"
    >
      {{ description }}
    </p>

    <p
      v-if="error"
      :class="clsx(
        ['text-base/6 text-error sm:text-sm/6'],
        $attrs.disabled && 'opacity-50',
        !description && 'mt-2'
      )"
    >
      {{ error }}
    </p>

  </div>

</template>

<script lang="ts" setup>
import clsx from 'clsx'

defineOptions({
  inheritAttrs: false
})

const model = defineModel<string>()

defineProps({
  label: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  resizable: {
    type: Boolean,
    default: false
  }
})

</script>
